'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('../../index');

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');
var dom = weex.requireModule('dom');
var globalEvent = weex.requireModule('globalEvent');
exports.default = {
  data: function data() {
    return {
      leftShow: true,
      rightShow: false,
      startX: 0,
      startY: 0,
      distanceX: 0,
      lbuttonMargin: false,
      moveX: 0,
      moveLength: 0,
      leftSlideFlag: false,
      distanceXFlag: 0,
      isMoveEnd: false,
      buttonBox_width: 0,
      button_width: 0,
      swipeX: true,
      swipeY: true
    };
  },

  props: {
    slideDirection: {
      //1:支持左滑按钮出来(按钮在右边)
      //2：支持右滑按钮出来(按钮在左边)
      type: Number,
      default: 1 //默认支持右滑
    },
    buttonsText: {
      type: Array,
      default: function _default() {
        return [{ value: '删除', background_color: '#F56428', color: '#ffffff' }];
      }
    },
    backAccept: {
      type: Number,
      default: 0
    }
  },
  methods: {
    alertMessage: function alertMessage(index) {
      _index.Core.toast(this.buttonsText[index].value);
      this.distanceX = 0;
    },
    backColorChange: function backColorChange(index) {
      var style1 = {
        backgroundColor: this.buttonsText[index].background_color
      };
      return style1;
    },
    colorChange: function colorChange(index) {
      var style2 = {
        fontSize: '32px',
        color: this.buttonsText[index].color
      };
      return style2;
    },
    checkTouchStart: function checkTouchStart(e) {
      var _this = this;

      var result = dom.getComponentRect(this.$refs.leftBox, function (option) {
        _this.buttonBox_width = option.size.width;
      });
      //Core.alert(e)
      if (this.slideDirection === 1) {
        //按钮在右边
        this.startX = e.changedTouches[0].pageX;
        this.startY = e.changedTouches[0].pageY;
      } else if (this.slideDirection === 2) {
        //按钮在左边
        this.startX = e.changedTouches[0].pageX;
        this.startY = e.changedTouches[0].pageY;
      }
      e.preventDefault();
    },
    checkTouchMove: function checkTouchMove(e) {
      //判断pageY和pageX
      if (this.slideDirection === 1) {
        this.moveX = e.changedTouches[0].pageX;
        var x = e.changedTouches[0].pageX;
        var y = e.changedTouches[0].pageY;
        if (Math.abs(x - this.startX) > Math.abs(y - this.startY)) {
          if (this.startX > x && this.distanceX !== -this.buttonBox_width && x - this.startX >= -this.buttonBox_width) {
            this.distanceXFlag = x - this.startX;
            this.distanceX = x - this.startX;
          } else if (this.startX < x && this.distanceX !== 0 && x - this.startX <= this.buttonBox_width) {
            this.distanceXFlag = x - this.startX;
            this.distanceX = -this.buttonBox_width + x - this.startX;
          }
        }
      } else if (this.slideDirection === 2) {
        this.moveX = e.changedTouches[0].pageX;
        var _x = e.changedTouches[0].pageX;
        var _y = e.changedTouches[0].pageY;
        if (Math.abs(_x - this.startX) > Math.abs(_y - this.startY)) {
          if (this.startX > _x && this.distanceX !== 0 && _x - this.startX > -this.buttonBox_width) {
            //左滑，禁止在没滑出按钮的时候左滑
            this.distanceXFlag = _x - this.startX; //小于0
            this.distanceX = this.buttonBox_width - (this.startX - _x);
          } else if (this.startX < _x && this.distanceX !== this.buttonBox_width && _x - this.startX <= this.buttonBox_width) {
            //右滑，禁止在按钮全部滑出的时候右滑
            this.distanceXFlag = _x - this.startX; //大于0
            this.distanceX = _x - this.startX;
          }
        }
      }
      e.preventDefault();
    },
    checkTouchEnd: function checkTouchEnd() {
      this.isMoveEnd = true;
      if (this.slideDirection === 1) {
        if (this.distanceXFlag > -80 && this.distanceXFlag < 0) {
          //当左滑没有超出一个按钮宽度大小的距离，按钮回退
          this.distanceX = 0;
        } else if (this.distanceXFlag < -80 && this.distanceXFlag > -this.buttonBox_width) {
          this.distanceX = -this.buttonBox_width;
        } else if (this.distanceXFlag <= -this.buttonBox_width) {
          this.distanceX = -this.buttonBox_width;
        } else if (this.distanceXFlag >= 80) {
          this.distanceX = 0;
        } else if (this.distanceXFlag < 80 && this.distanceXFlag > 0) {
          this.distanceX = -this.buttonBox_width;
        }
      } else if (this.slideDirection === 2) {
        if (this.distanceXFlag < 80 && this.distanceXFlag > 0) {
          //当右滑没有超出一个按钮宽度大小的距离，按钮回退
          this.distanceX = 0;
        } else if (this.distanceXFlag > 80) {
          //当右滑超出一个按钮宽度大小，按钮全部滑出
          this.distanceX = this.buttonBox_width;
        } else if (this.distanceXFlag < -80) {
          //当左滑按钮回去
          this.distanceX = 0;
        } else if (this.distanceXFlag > -80 && this.distanceXFlag < 0) {
          this.distanceX = this.buttonBox_width;
        }
      }
    }
  },
  mounted: function mounted() {
    //this.$alert(this.backAccept)
  },

  computed: {
    changeStyle: function changeStyle() {
      var distanceX = this.distanceX;

      var style = {
        transitionProperty: 'transform',
        transform: 'translateX(' + this.distanceX + 'px)',
        'transition-duration': this.isMoveEnd ? '2s' : '0',
        'transition-timing-function': 'linear'
      };
      return style;
    }
  },
  watch: {
    backAccept: function backAccept(newValue, oldValue) {
      if (this.backAccept === 1) {
        if (this.distanceX === this.buttonBox_width || this.distanceX === -this.buttonBox_width) {
          this.distanceX = 0;
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-swipe-cell/index.vue
// module id = 404
// module chunks = 0 1